module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section numbers"
  }, [_c('ol', {
    staticClass: "numbers__container"
  }, _vm._l((_vm.content.numbers), function(item, i) {
    return _c('li', {
      staticClass: "numbers__item"
    }, [_vm._v(_vm._s(item.text)), _c('div', {
      staticClass: "numbers__border"
    })])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cba976f"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-numbers/custom-numbers.pug
// module id = 521
// module chunks = 1